import React, { useState } from 'react';
import api from "../lib/api";
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { FiUser, FiLock, FiTrash2 } from 'react-icons/fi';

export default function AccountSettings() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [passwordData, setPasswordData] = useState({ old_password: '', new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwordData.new_password !== passwordData.confirm_password) {
      toast.error('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/change-password', { old_password: passwordData.old_password, new_password: passwordData.new_password });
      toast.success('Password changed successfully');
      setPasswordData({ old_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    if (!window.confirm('Are you sure? This cannot be undone.')) return;
    const confirm = window.prompt('Type DELETE to confirm:');
    if (confirm !== 'DELETE') return;
    try {
      await api.delete('/auth/delete-account');
      toast.success('Account deleted');
      logout();
      navigate('/login');
    } catch (error) {
      toast.error('Failed to delete account');
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold font-heading text-text-main">ACCOUNT SETTINGS</h1>
      
      <div className="bg-surface border border-border/40 rounded-sm p-6">
        <h2 className="text-xl font-bold uppercase font-heading mb-4 flex items-center gap-2"><FiUser /> Profile</h2>
        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-text-muted mb-1">Name</label>
            <input value={user?.name || ''} disabled className="w-full px-4 py-2 bg-black/50 border border-border text-text-main rounded-sm" />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-muted mb-1">Email</label>
            <input value={user?.email || ''} disabled className="w-full px-4 py-2 bg-black/50 border border-border text-text-main rounded-sm" />
          </div>
        </div>
      </div>

      <div className="bg-surface border border-border/40 rounded-sm p-6">
        <h2 className="text-xl font-bold uppercase font-heading mb-4 flex items-center gap-2"><FiLock /> Change Password</h2>
        <form onSubmit={handleChangePassword} className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-text-muted mb-1">Current Password</label>
            <input type="password" value={passwordData.old_password} onChange={(e) => setPasswordData({...passwordData, old_password: e.target.value})} required className="w-full px-4 py-2 bg-black/50 border border-border text-text-main rounded-sm" />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-muted mb-1">New Password</label>
            <input type="password" value={passwordData.new_password} onChange={(e) => setPasswordData({...passwordData, new_password: e.target.value})} required className="w-full px-4 py-2 bg-black/50 border border-border text-text-main rounded-sm" />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-muted mb-1">Confirm New Password</label>
            <input type="password" value={passwordData.confirm_password} onChange={(e) => setPasswordData({...passwordData, confirm_password: e.target.value})} required className="w-full px-4 py-2 bg-black/50 border border-border text-text-main rounded-sm" />
          </div>
          <button type="submit" disabled={loading} className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase px-4 py-2 rounded-sm">
            {loading ? 'CHANGING...' : 'CHANGE PASSWORD'}
          </button>
        </form>
      </div>

      <div className="bg-surface border border-destructive/20 rounded-sm p-6">
        <h2 className="text-xl font-bold uppercase font-heading mb-4 text-destructive flex items-center gap-2"><FiTrash2 /> Danger Zone</h2>
        <p className="text-sm text-text-muted mb-4">Once deleted, there is no going back.</p>
        <button onClick={handleDeleteAccount} className="bg-destructive/10 text-destructive border border-destructive/50 hover:bg-destructive/20 font-bold uppercase px-4 py-2 rounded-sm">
          DELETE ACCOUNT
        </button>
      </div>
    </div>
  );
}
